import * as React from 'react'
import * as PropTypes from 'prop-types'

import gCashStatus from '../../../../../services/data/gCashStatus'
import {
  GCashContainer,
  GCashStatusMessage,
  GCashIcon,
  GCashMessage,
  GCashHeader,
  GCashActionButton,
  GCashDescription,
  RightButton,
} from './GCashStatus.style'

const GCashStatus = ({
  advanceAccount,
  gCashData,
  mobileNumber,
  gCashCallback,
}) => {
  return (
    <>
      {(advanceAccount || gCashData.status === gCashStatus.pendingLink) && (
        <GCashContainer>
          {gCashData &&
            (gCashData.status === gCashStatus.enrolled ||
              gCashData.status === gCashStatus.verified) && (
              <GCashStatusMessage>
                <GCashIcon />
                <GCashMessage>
                  <GCashHeader>
                    <div>{gCashData.mobileNumber}</div>
                    <GCashActionButton onClick={gCashCallback}>
                      Unlink
                    </GCashActionButton>
                  </GCashHeader>
                  <GCashDescription>
                    GCash account linked! Start using your GCash account in
                    Ayala Malls to earn Zing Points.
                  </GCashDescription>
                </GCashMessage>
              </GCashStatusMessage>
            )}

          {gCashData && gCashData.status === gCashStatus.pendingLink && (
            <GCashStatusMessage>
              <GCashIcon />
              <GCashMessage>
                <GCashHeader>
                  <div>Validating {gCashData.mobileNumber || mobileNumber}</div>
                </GCashHeader>
                <GCashDescription>
                  We are currently validating your mobile number with GCash.
                  This may take around 24-48 hours.
                </GCashDescription>
              </GCashMessage>
            </GCashStatusMessage>
          )}

          {/* ST-7033 - Profile :: Gcash Linking : Remove CTA

          {gCashData && gCashData.status === gCashStatus.noRequest && (
            <GCashStatusMessage onClick={gCashCallback} isButton>
              <GCashIcon />
              <GCashMessage>
                <GCashHeader>
                  <div>Earn Zing Points with GCash</div>
                  <div>
                    <RightButton class="right-button" />
                  </div>
                </GCashHeader>
                <GCashDescription>
                  Start earning Zing Points using your GCash. Link your mobile
                  number now.
                </GCashDescription>
              </GCashMessage>
            </GCashStatusMessage>
          )} */}

          {gCashData && gCashData.status === gCashStatus.invalid && (
            <GCashStatusMessage>
              <GCashIcon onClick={gCashCallback} isButton />
              <GCashMessage>
                <GCashHeader>
                  <div>Failed to load GCash</div>
                  <div>
                    <RightButton class="right-button" />
                  </div>
                </GCashHeader>
                <GCashDescription>
                  <div>{gCashData.error}</div>
                </GCashDescription>
              </GCashMessage>
            </GCashStatusMessage>
          )}
        </GCashContainer>
      )}
    </>
  )
}

GCashStatus.defaultProps = {
  advanceAccount: false,
  gCashData: null,
  mobileNumber: '09123456789',
  gCashCallback: () => {},
}

GCashStatus.propTypes = {
  advanceAccount: PropTypes.bool,
  gCashData: PropTypes.object,
  mobileNumber: PropTypes.string,
  gCashCallback: PropTypes.func,
}

export default GCashStatus
